import { render, staticRenderFns } from "./assetCleanupList.vue?vue&type=template&id=47a58b50"
import script from "./assetCleanupList.vue?vue&type=script&lang=js"
export * from "./assetCleanupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports